export const VALID_AGREE_REQ = 'VALID_AGREE_REQ';